// ColorCircle.tsx
import React from "react";
import { useInView } from "../../../../../custom-hooks/useInView";
import "./ColorCircle.css";

interface Props {
  color: string;
  index: number;
  baseDelay?: number;
}

export const ColorCircle = ({ color, index, baseDelay = 0.15 }: Props) => {
  const { ref, isVisible } = useInView({ threshold: 0.5, resetOnExit: true });

  const style = {
    backgroundColor: color,
    transitionDelay: `${index * baseDelay}s`,
  };

  return (
    <span
      ref={ref}
      className={`color-circle ${isVisible ? "visible" : ""}`}
      style={style}
    />
  );
};
